export default "__VITE_ASSET__ywcUJleq__"